/**
 * Evaluate declarative top-level property visibility metadata.
 *
 * `visibleWhen` is UI-only schema metadata; it never changes the stored
 * object value or the export domain. The supported form is deliberately
 * small and data-only so schemas remain serializable:
 * `{ property: 'type', equals: 3 }` or `{ property: 'type', in: [1, 2] }`.
 */
export function isSchemaPropertyVisible(node, propName) {
    const condition = node?.schemaV2?.properties?.[propName]?.visibleWhen;
    if (!condition) return true;
    const actual = node[condition.property];
    if (Object.prototype.hasOwnProperty.call(condition, 'equals')) return actual === condition.equals;
    if (Array.isArray(condition.in)) return condition.in.includes(actual);
    return true;
}

/** Return object-property names whose values can change a visibility rule. */
export function schemaPropertyVisibilityDependencies(schema) {
    return [...new Set(Object.values(schema?.properties ?? {})
        .map(meta => meta?.visibleWhen?.property)
        .filter(Boolean))];
}
